import { GET_TASK, GET_TASK_SUCCESS, GET_TASK_ERROR} from './actionTypes';

// P01021-145: filtro por servidor (estado, rack, estación, posición, rango de prioridad).
export const getTask = (user, size, page, status, rack, workstation, position, priorityMin, priorityMax) => {
    return {
        type: GET_TASK,
        payload: { user, size, page, status, rack, workstation, position, priorityMin, priorityMax}
    }
}

export const getTaskSuccess = (tasks, message) => {
    return {
        type: GET_TASK_SUCCESS,
        payload: {tasks, message}
    }
}

export const getTaskError = (msg) => {
    return {
        type: GET_TASK_ERROR,
        payload: msg
    }
}
